'use strict';

/** @type {import('./functionApply')} */
module.exports = Function.prototype.apply;



//////////////////
// WEBPACK FOOTER
// ./node_modules/call-bind-apply-helpers/functionApply.js
// module id = 9RdJ
// module chunks = 0